import React from 'react';

function ThankYouScreen() {
    return (
        <div className="App">
            <div className="invitation-card success-card">
                <div className="ornament-top"></div>
                <h1 style={{ fontFamily: "'Cormorant Garamond', cursive", fontSize: '2.5rem', fontWeight: '400', color: '#d4af37' }} className="elegant-title">Grazie</h1>
                <h2 className="elegant-subtitle" style={{ fontStyle: 'italic', fontWeight: '300', fontSize: '1.3rem', lineHeight: '1.6', color: '#d4af37' }}>
                    La tua presenza ha reso questo momento ancora più speciale.
                </h2>
                <div className="divider"></div>
                <div className="ornament-bottom"></div>
            </div>
        </div>
    );
}

export default ThankYouScreen;
